import { render, staticRenderFns } from "./skills.vue?vue&type=template&id=3baf8286&scoped=true&"
import script from "./skills.vue?vue&type=script&lang=js&"
export * from "./skills.vue?vue&type=script&lang=js&"
import style0 from "./skills.vue?vue&type=style&index=0&id=3baf8286&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf8286",
  null
  
)

export default component.exports